import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import addon_sensors from '@devices/settings/device_settings/addon_sensors.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import virtual_components_pro_devices from '@devices/settings/device_settings/virtual_components_pro_devices.js';
import networks_gen_2_pro from '@devices/settings/device_settings/networks_gen_2_pro.js';
import share from '@devices/settings/device_settings/share.js';
import emeter_triphase_settings_gen_2 from '@devices/settings/device_settings/emeter_triphase_settings_gen_2.js';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

export default [
	webhooks_gen_2,
	addon_sensors,
	scripts_gen_2,
	virtual_components_pro_devices,
	networks_gen_2_pro,
	bluetooth_gen_2,
	{
		title: 'application_settings',
		components: [
			{ title: 'ai_model', component: 'ai_model' },
			{
				title: 'device_card_customization',
				component: 'customize_device_content',
			},
			{ title: 'appliance_type', component: 'appliance_type' },
			{
				title: 'consumption_calculation',
				component: 'consumption_calculation',
			},
			{
				title: 'consumption_hierarchy',
				component: 'consumption_hierarchy',
				test_user: true,
			},
			{ title: 'pin_lock', component: 'pin_lock' },
			{ title: 'exclude_event_log', component: 'exclude_event_log' },
		],
	},
	share,
	emeter_triphase_settings_gen_2,
];
